import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//Component
import { AppComponent } from './app.component';
import { PageNotfoundComponent } from './shared/components/page-notfound/page-notfound.component';
//Services
import { SpinnerService } from './shared/services/spinner.service';
import { InlineEditorService } from './shared/services/inline-editor.service';
import { LoginAgainService } from './shared/services/login-again.service';
import { CookieService, CookieOptions } from 'angular2-cookie/core';
import { CookieManagerService } from './shared/services/cookie-manager.service';
import { AlertManagerService } from './shared/services/alert-manager.service';
import { AuthService } from './shared/services/auth.service';

import { loginRoutes, loginRoutingProviders } from './login/login.routes';


/**
 * main routing
 */
const appRoutes: Routes = [

    {
        path: "preauth",
        component: AppComponent,
        children: [
            {
                path: '',
                children: [
                    ...loginRoutes
                ]
            }
        ]
    },
    {
        path: '**',
        component: PageNotfoundComponent,
        pathMatch: 'full'
    }
];

/**
 * main providers
 */
export const appRoutingProviders: any[] = [
    SpinnerService,
    InlineEditorService,
    LoginAgainService,
    AuthService,
    CookieService,
    { provide: CookieOptions, useValue: false },
    CookieManagerService,
    AlertManagerService,
    loginRoutingProviders
];

export const appRouting: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/app/app.routes.ts